<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Xem điểm kiểm tra</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <MarkViewFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <MarkViewTable :query="query" :room="room" :teacher="teacher" :subjects="subjects" />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import MarkViewFilter from '@/modules/exam/MarkViewFilter.vue'
import MarkViewTable from '@/modules/exam/MarkViewTable.vue'

export default {
  components: {
    StudentBlankView,
    MarkViewFilter,
    MarkViewTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      room: {},
      query: {},
      teacher: {},
      type: null,
      grade: null
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, room, teacher, subjects) {
      this.action.state = 'filtered'
      this.query = params
      this.room = room
      this.subjects = subjects
      this.teacher = teacher
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
